import styles from './Template.module.scss'
import ServicesFV from 'components/services/common/ServicesFV'
import Summary from 'components/services/common/Summary'
import MobileAppDevelopment from 'components/services/common/MobileAppDevelopment'
import DevOpsServiceLink from 'components/services/common/DevOpsServiceLink'
import Assignment from 'components/services/common/Assignment'
import Whyi3 from 'components/services/common/Whyi3'
import { LanguageFrameworksItems } from './components/LanguageFrameworks/LanguageFrameworks'
import LanguageFrameworks from './components/LanguageFrameworks'
import Process from 'components/services/common/Process'
import ArchitectureExample from './components/ArchitectureExample/ArchitectureExample'
import InHouseSupport from '../common/InHouseSupport'
import RelatedPosts from 'components/services/common/RelatedPosts'
import type { RelatedPostsItem } from 'components/services/common/RelatedPosts/RelatedPosts'
import FooterCTA from 'components/common/FooterCTA'

const paths = [
  { name: 'TOP', url: '/' },
  { name: 'Services', url: '#' },
  { name: 'アプリケーション開発', url: '#' },
]

const ServicesFVList = {
  category: 'モダンアプリケーション開発',
  title: (
    <>
      <span>ア</span>
      <span>プ</span>
      <span>リ</span>
      <span>ケ</span>
      <span>ー</span>
      <span>シ</span>
      <span>ョ</span>
      <span>ン</span>
      <span>開</span>
      <span>発</span>
    </>
  ),
  text: (
    <>
      クラウドネイティブアーキテクチャの利点を最大限に活用し、アジャイル開発手法を効果的に適用しながら、優れたUX/UIを実現するモダンなアプリケーション開発を提供します。
    </>
  ),
  imgSrc: '/img/services/services_fv_application_development.webp',
  alt: 'アプリケーション開発',
}

const summaryList = [
  {
    text: 'UX/UIに焦点をあてたプロダクト開発手法を用いて、アプリケーションにおける価値の最大化を目指します。',
  },
  {
    text: 'クラウド専門化チームの豊富な知識と経験をもとに、クラウドネイティブの利点を最大限活用した柔軟性とスケーラビリティに優れたアプリケーションの設計・構築を提供します。私たちのアジャイル開発アプローチにより、迅速かつ効率的にプロジェクトを進行させ、Swift、Kotlin、Flutter、Goなどの最新技術を駆使して、最適なソリューションを実現します。',
  },
  {
    text: 'また、AIを取り入れたアプリケーション開発の実績もあり、様々なニーズに対応可能です。昨今ではラボ型開発の取り組みも多くなっており、グローバルなリソースを効果的に活用し、高品質なアプリケーション開発をサポートします。',
  },
]

const assignmentList = [
  {
    title: '継続開発を考慮したアプリケーション開発ができていない',
    text: 'クラウドネイティブの利点を最大限に活用したアプリケーション開発を実現するため、アジャイル開発手法を採用し、初期リリース後も継続的なグロースをサポートします。アプリケーション開発において、クラウドネイティブアーキテクチャとアジャイル開発の手法を融合することで、柔軟でスケーラブルなソリューションを提供し、迅速な市場投入と持続的な改善を実現します。',
  },
  {
    title: 'アプリケーションのリプレイスに苦労している',
    text: 'グローバル拠点も活用したソースコードの解読、設計、アプリケーションのMVP開発など、既存アプリケーションから効率的なリプレイスを支援します。',
  },
  {
    title: 'セキュリティに不安がある',
    text: 'アプリケーション開発で発生するセキュリティの課題に対して、クラウドネイティブの利点を最大限に活用し、よりセキュアなサービス基盤構築をご支援します。クラウドネイティブなアプローチにより、セキュリティの向上と柔軟なスケーリングを同時に実現し、アプリケーション開発の全工程にわたって強固なセキュリティ対策を提供します。',
  },
]

const reasonList = [
  {
    icon: '/images/icons/icon_knowledge.svg',
    title: 'アジャイル開発の実績と経験',
    text: '持続的なプロダクトのグロースを見据えたアジャイル開発を得意としています。',
  },
  {
    icon: '/images/icons/icon_onestop.svg',
    title: 'UX/UIデザインチームとの密な連携',
    text: 'アプリケーション開発において、クラウドネイティブアーキテクチャとアジャイル開発手法を採用し、UX/UIデザインチームとの密接な連携を実現しています。これにより、UX/UI設計と開発プロセスが有機的に統合され、効率的かつ迅速な開発体制を確立しています。',
  },
  {
    icon: '/images/icons/icon_innovative.svg',
    title: '専門的な知識と経験',
    text: [
      'アプリケーション開発において、クラウドネイティブアーキテクチャの利点を活用し、専門的な知識・経験を組み合わせた開発を行っています。',
      'AIを取り入れたいなどの最先端のご要望にもお応えでき、実績に基づく専門的な知識・経験の組み合わせで高品質なサービスを提供します。SaaSから業務システム、モバイルアプリからWebサービス、ECサイトまで、様々なジャンルで豊富な開発実績を有しております。',
    ],
  },
]

const languageFrameworksList: LanguageFrameworksItems[] = [
  {
    category: '開発環境',
    items: [
      {
        src: '/img/services/technology_stack_image_aws.svg',
        alt: 'aws',
      },
      {
        src: '/img/services/technology_stack_image_google-cloud.svg',
        alt: 'Google Cloud',
      },
      {
        src: '/img/services/technology_stack_image_Azure.svg',
        alt: 'Azure',
      },
      {
        src: '/img/services/technology_stack_image_cloudflare.svg',
        alt: 'Cloudflare',
      },
    ],
  },
  {
    category: 'プロジェクト管理・コミュニケーション',
    items: [
      {
        src: '/img/services/technology_stack_image_backlog.svg',
        alt: 'backlog',
      },
      {
        src: '/img/services/technology_stack_image_slack.svg',
        alt: 'slack',
      },
      {
        src: '/img/services/technology_stack_image_google-meets.svg',
        alt: 'Google Meets',
      },
      {
        src: '/img/services/technology_stack_image_zoom.svg',
        alt: 'ZOOM',
      },
    ],
  },
  {
    category: 'パートナー',
    items: [
      {
        src: '/img/services/technology_stack_image_amazonecs.svg',
        alt: 'Amazon ECS Delivery Partner',
      },
      {
        src: '/img/services/technology_stack_image_aws_selecttier.svg',
        alt: 'AWS Select Tier Services Partner',
      },
      {
        src: '/img/services/technology_stack_image_gitlab-partner.svg',
        alt: 'GitLab Partner',
      },
    ],
  },
  {
    category: '開発エージェント',
    items: [
      {
        src: '/img/services/technology_stack_image_copilot.svg',
        alt: 'GitHub Copilot',
      },
      {
        src: '/img/services/technology_stack_image_cursor.svg',
        alt: 'Cursor',
      },
      {
        src: '/img/services/technology_stack_image_devin.svg',
        alt: 'Devin',
      },
      {
        src: '/img/services/technology_stack_image_claude.svg',
        alt: 'Claude',
      },
    ],
  },
  {
    category: 'デザイン・開発ツール',
    items: [
      {
        src: '/img/services/technology_stack_image_Figma.svg',
        alt: 'Figma',
      },
      {
        src: '/img/services/technology_stack_image_gitlab.svg',
        alt: 'GitLab',
      },
      {
        src: '/img/services/technology_stack_image_github.svg',
        alt: 'GitHub',
      },
      {
        src: '/img/services/technology_stack_image_bitrise.svg',
        alt: 'bitrise',
      },
      {
        src: '/img/services/technology_stack_image_browserstack.svg',
        alt: 'BrowserStack',
      },
      {
        src: '/img/services/technology_stack_image_git.svg',
        alt: 'Git',
      },
      {
        src: '/img/services/technology_stack_image_docker.svg',
        alt: 'Docker',
      },
      {
        src: '/img/services/technology_stack_image_kubernetes.svg',
        alt: 'Kubernetes',
      },
    ],
  },
  {
    category: '言語',
    items: [
      {
        src: '/img/services/technology_stack_image_js.svg',
        alt: 'JavaScript',
      },
      {
        src: '/img/services/technology_stack_image_ts.svg',
        alt: 'TypeScript',
      },
      {
        src: '/img/services/technology_stack_image_php.svg',
        alt: 'php',
      },
      {
        src: '/img/services/technology_stack_image_go.svg',
        alt: 'Go',
      },
      {
        src: '/img/services/technology_stack_image_swift.svg',
        alt: 'Swift',
      },
      {
        src: '/img/services/technology_stack_image_kotlin.svg',
        alt: 'Kotlin',
      },
      {
        src: '/img/services/technology_stack_image_java.svg',
        alt: 'Java',
      },
    ],
  },
  {
    category: 'フレームワーク',
    items: [
      {
        src: '/img/services/technology_stack_image_react.svg',
        alt: 'React',
      },
      {
        src: '/img/services/technology_stack_image_react-native.svg',
        alt: 'React Native',
      },
      {
        src: '/img/services/technology_stack_image_angular.svg',
        alt: 'Angular',
      },
      {
        src: '/img/services/technology_stack_image_vue.svg',
        alt: 'Vue.js',
      },
      {
        src: '/img/services/technology_stack_image_next.svg',
        alt: 'Next.js',
      },
      {
        src: '/img/services/technology_stack_image_laravel.svg',
        alt: 'Laravel',
      },
      {
        src: '/img/services/technology_stack_image_springframework.svg',
        alt: 'Spring Framework',
      },
      {
        src: '/img/services/technology_stack_image_flutter.svg',
        alt: 'Flutter',
      },
    ],
  },
]

const processList = [
  {
    title: 'ヒアリング',
    term: '1か月~',
    text: '既存システムの課題やご要望をヒアリングし、目指す効果を明文化します。アジャイル開発/ウォーターフォール開発など最適な開発手法についてもアドバイスさせていただきます。',
    deliverables: [
      { link: '#', name: 'ヒアリング・ビジネス要求定義' },
      { link: '#', name: '競合分析' },
      { link: '#', name: 'エキスパートレビュー' },
      { link: '#', name: 'ユーザーインタビュー' },
      { link: '#', name: '現行システムの理解' },
      { link: '#', name: 'スコープ定義' },
    ],
  },
  {
    title: '要件定義、既存システム調査',
    term: '1か月~',
    text: '既存システムのUX/UIを改善するための要件を確定させます。同時に改善の目的と期待される効果の仮説を明確にします。',
    deliverables: [
      { link: '#', name: '機能要件一覧' },
      { link: '#', name: '非機能要件一覧' },
      { link: '#', name: 'システム構成図' },
      { link: '#', name: 'API仕様書' },
      { link: '#', name: 'シーケンス図' },
      { link: '#', name: 'DB定義書' },
      { link: '#', name: 'モダンコンポーネントUI設計（Figma）' },
    ],
  },
  {
    title: '開発/運用',
    term: '3か月~',
    text: '実用性を加味したUX設計を考慮し、開発実装を行います。運用フェーズではグロースを意識して内製化支援を提供することも可能です。',
    deliverables: [
      { link: '#', name: 'テスト計画書' },
      { link: '#', name: 'ソースコード' },
      { link: '#', name: 'IaC (Infrastructure as Code)' },
    ],
  },
]

const InHouseSupportList = [
  {
    text: 'アプリケーション開発における内製化支援を通じて、迅速かつ柔軟な開発プロセスを自社内で構築できます。クラウドネイティブの技術を活用し、アジャイル開発の手法を取り入れることで、アプリケーション開発の効率を大幅に向上させることが可能です。',
  },
  {
    text: '内製化支援のメリットとして、プロジェクトのスピードと品質の向上が挙げられます。アジャイル開発の導入により、チームは迅速なフィードバックループと継続的な改善が可能になり、クラウドネイティブのアプローチが、スケーラブルで堅牢な基盤を提供します。',
  },
  {
    text: 'これにより、持続可能な開発体制が確立し、長期的なコスト削減と競争力強化が実現します。',
  },
]

const relatedPostsList: RelatedPostsItem = {
  sectionTitle: 'アプリケーション開発の関連記事',
  relatedPosts: [
    {
      title: '【発注担当者必見】アプリ開発の失敗を防ぐ！発注前に確認すべき30のチェックリスト',
      link: 'https://aitria.co.jp/in-pocket/application-checklist/',
      thumbnail: 'https://aitria.co.jp/in-pocket/wp-content/uploads/2025/09/application-checklist.png',
      day: '2025年10月20日',
      category: '開発・エンジニアリング',
    },
    {
      title: 'アプリ開発とは？システム開発の違いや開発手法を解説',
      link: 'https://aitria.co.jp/in-pocket/app-development/',
      thumbnail: 'https://aitria.co.jp/in-pocket/wp-content/uploads/2026/01/251223_whats_app_dev.png',
      day: '2026年1月9日',
      category: '開発・エンジニアリング',
    },
    {
      title: 'アプリ開発の費用相場はいくら？見積もりの見方と合わせて解説',
      link: 'https://aitria.co.jp/in-pocket/app-development-cost/',
      thumbnail: 'https://aitria.co.jp/in-pocket/wp-content/uploads/2026/01/260104_app_dev_cost.png',
      day: '2026年1月14日',
      category: '開発・エンジニアリング',
    },
    {
      title: '“作って終わり”から“伸ばす設計”へ。アプリグロースの現在地をReproと探る',
      link: 'https://aitria.co.jp/in-pocket/app_development_proposal/',
      thumbnail: 'https://aitria.co.jp/in-pocket/wp-content/uploads/2026/01/app_development_proposal.png',
      day: '2026年1月19日',
      category: '開発・エンジニアリング',
    },
  ],
}

const ApplicationDevelopment: React.FC = () => {
  return (
    <>
      <ServicesFV ServicesFVEach={ServicesFVList} paths={paths} />
      <Summary list={summaryList} />
      <MobileAppDevelopment />
      <DevOpsServiceLink />
      <div className={styles.backGround}>
        <Assignment list={assignmentList} />
      </div>
      <Whyi3 list={reasonList} />
      <div className={styles.backGround}>
        <LanguageFrameworks languageFrameworksList={languageFrameworksList} />
      </div>
      <Process list={processList} isVisibleAnnotation />
      <ArchitectureExample />
      <InHouseSupport list={InHouseSupportList} subTitle="アジャイル開発における内製化支援" />
      <div className={styles.backGroundGray}>
        <RelatedPosts RelatedPostsEach={[relatedPostsList]} />
      </div>
      <FooterCTA />
    </>
  )
}

export default ApplicationDevelopment
